import React from "react"
import { Box, Paper, Typography, Button } from "@material-ui/core"
import SearchIcon from "@material-ui/icons/Search"

const GridNoRecordsText = ({
  description = "There are no records available.",
  buttonText,
  onButtonClick,
  gridNoRecordsText = "title",
}) => {
  let title = gridNoRecordsText
  return (
    <Box
      elevation={1}
      style={{
        borderRadius: 20,
        textAlign: "center",
      }}
    >
      <Box display="flex" justifyContent="center" mb={3}>
        <Box
          style={{
            width: 90,
            height: 90,
            borderRadius: "50%",
            background: "#EEF4FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SearchIcon
            style={{
              fontSize: 45,
              color: "#3F51B5",
            }}
          />
        </Box>
      </Box>

      <Typography
        variant="h5"
        style={{
          fontWeight: 600,
          marginBottom: 10,
        }}
      >
        {title}
      </Typography>

      <Typography variant="body2" color="textSecondary">
        {description}
      </Typography>

      {buttonText && (
        <Box mt={4}>
          <Button variant="contained" color="primary" onClick={onButtonClick}>
            {buttonText}
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default GridNoRecordsText
export { GridNoRecordsText }
